import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeRoutingModule } from './code-routing.module';
import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgsRevealModule } from 'ngx-scrollreveal';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { CodeGridComponent } from './code-grid/code-grid.component';
import { CodeComponent } from '../code/code/code.component';
import { DlaComponent } from './dla/dla.component';
import { MvComponent } from './mv/mv.component';
import { SlkComponent } from './slk/slk.component';
import { LuxComponent } from './lux/lux.component';
import { DiscoverComponent } from './discover/discover.component';
import { BlComponent } from './bl/bl.component';
import { AnthemComponent } from './anthem/anthem.component';



@NgModule({
  declarations: [
    CodeComponent,
    DlaComponent,
    MvComponent,
    CodeGridComponent,
    SlkComponent,
    LuxComponent,
    DiscoverComponent,
    BlComponent,
    AnthemComponent,
  ],
  imports: [
    CommonModule,
    CodeRoutingModule,
    BrowserAnimationsModule,
    NgsRevealModule,
    ScrollToModule.forRoot(),
    SharedModule
  ]
})

export class CodeModule { }
